export default __webpack_public_path__ + "static/media/garden-04.b1757bfc.jpg";